import { Component } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-count-differences',
  templateUrl: './count-differences.component.html',
  styleUrls: ['./count-differences.component.css']
})
export class CountDifferencesComponent extends GeneralExerciseComponent {

  encodings: number[][] = [];
  solution: number;
  clickedValueCount: number;
  clickedValuesEqual: number[] = [];
  isEqualSolved: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
    this.encodings = [];
    this.solution = -1;
    this.clickedValueCount = -1;
    this.isEqualSolved = false;
    this.clickedValuesEqual = [];
  }

  checkSolution() {
    if (this.solution === this.clickedValueCount) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      this.solved = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  checkEqualSolution() {
    this.isEqualSolved = true;
    for (let i = 0; i < this.clickedValuesEqual.length; i++) {
      if (this.clickedValuesEqual[i] === -1) {
        this.isEqualSolved = false;
        break;
      }
      // Both Symbols are equal. User has to click on equal=1.
      if (this.encodings[0][i] === this.encodings[1][i] && this.clickedValuesEqual[i] === 1) {
        this.isEqualSolved = false;
      } else {
        // Both Symbols are not equal. User has to click on unequal=0.
        if (this.encodings[0][i] !== this.encodings[1][i] && this.clickedValuesEqual[i] === 0) {
          this.isEqualSolved = false;
        }
      }
    }

    if (this.isEqualSolved) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.counter += 1;
    this.initValues();
  }

  setClickedValueCount(i: number) {
    this.clickedValueCount = i;
    this.checkSolution();
  }

  setClickedValueEqual(index: number, value: number) {
    this.clickedValuesEqual[index] = value;
  }

  setEncoding(encodings: number[][]) {
    this.encodings = encodings;

    let unequalsCounter = 0;
    for (let i = 0; i < this.encodings[0].length; i++) {
      this.clickedValuesEqual.push(-1);
      if (this.encodings[0][i] !== this.encodings[1][i]) {
        unequalsCounter ++;
      }
    }

    this.solution = unequalsCounter;
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

  getCodeWidth() {
    const width = 100 / this.encodings[0].length;
    return width.toString() + '%';
  }

}
